import * as React from 'react';
import { filter } from 'lodash';
import classNames from 'classnames';
import { domToReact, htmlToDOM } from 'html-react-parser';
import { parse, stringify } from 'query-string';

export interface ICategoryFilterProps {
    /* DOM to parse */
    dom: string;
    /** URL query string */
    query: string;
    /** React-router link component to use instead of HTML A tag. If defined href is passed as "to" prop. */
    link?: any;
    /** Navigation action */
    navigate: (query: string) => void;
}

const DummyCheck: React.FunctionComponent<ICategoryFilterProps & { domNode: any }> = (props) => {
    let Elem: any = 'a';
    if (props.link) {
        Elem = props.link;
    } else {
        Elem = 'a';
    }

    const q = parse(props.query);
    const { domNode } = props;

    const { class: className, ...rest } = domNode.attribs;

    const k = domNode.attribs['data-key'];
    const v = domNode.attribs['data-value'];
    const d = domNode.attribs.checked !== undefined;

    const [checked, setChecked] = React.useState(d);

    return (
        <input
            {...rest}
            className={className}
            type="checkbox"
            checked={checked}
            onChange={(e) => {
                const target = '?' + stringify({
                    ...q,
                    [k]: e.target.checked,
                });
                props.navigate(target);
                setChecked(!checked);
            }}
        />
    );
};

const CategoryFilter: React.FunctionComponent<ICategoryFilterProps> = (props) => {

    let Elem: any = 'a';
    if (props.link) {
        Elem = props.link;
    } else {
        Elem = 'a';
    }

    const q = parse(props.query);

    const parserOptions = {
        replace: (domNode) => {
            if (domNode.name) {
                if (!!domNode.attribs['data-key']) {

                    if (domNode.name === 'a') {
                        const inner = domToReact(domNode.children, parserOptions);
                        const { class: className, href, ...rest } = domNode.attribs;

                        const k = domNode.attribs['data-key'];
                        const v = domNode.attribs['data-value'];
                        const d = domNode.attribs['data-default'] !== undefined;

                        let isActive = false;

                        if ((q[k] && v && q[k] === v) || (!q[k] && d)) {
                            isActive = true;
                        }

                        const target = '?' + stringify({
                            ...q,
                            [k]: v,
                        });

                        return (
                            <Elem
                                {...rest}
                                {...(props.link ? {
                                    to: target,
                                } : {
                                    href: target,
                                })}
                                className={classNames(filter(className, (x) => x === 'active'), { active: isActive, })}
                                isActive={() => false}
                            >
                                {inner}
                            </Elem>
                        );
                    }

                    if (domNode.name === 'select') {
                        const inner = domToReact(domNode.children, parserSelectOptions);
                        const { class: className, ...rest } = domNode.attribs;

                        const k = domNode.attribs['data-key'];
                        const value = q[k] || '';

                        return (
                            <select
                                value={value}
                                onChange={(e) => {
                                    const target = '?' + stringify({
                                        ...q,
                                        [k]: e.target.value,
                                    });

                                    props.navigate(target);
                                }}
                            >
                                {inner}
                            </select>
                        );
                    }

                    if (domNode.name === 'input' && domNode.attribs.type === 'checkbox') {
                        return (
                            <DummyCheck {...props} domNode={domNode} />
                        );
                    }
                }

                if (domNode.name === 'option') {
                    return (
                        <React.Fragment />
                    );
                }
            }
            return false;
        },
    };

    const parserSelectOptions = {
        replace: (domNode: any) => {
            if (domNode.name && domNode.name === 'option') {
                const inner = domToReact(domNode.children, parserOptions);
                const { class: className, selected, ...rest } = domNode.attribs;
                return (
                    <option {...rest}>
                        {inner}
                    </option>
                );
            }
            return false;
        },
    };

    // Main output

    const domTree = htmlToDOM(props.dom.replace(/>\s+</g, '><'));

    return (
        <React.Fragment>
            {domToReact(domTree, parserOptions)}
        </React.Fragment>
    );
};

CategoryFilter.displayName = 'CategoryFilter';

export default CategoryFilter;
